<template>
  <div v-if="!type" class="dialog">
    <el-dialog
      v-model="isShowVisible"
      :width="width || '50%'"
      :title="title || ''"
      :close-on-click-modal="!clickModal"
      :top="top"
      append-to-body
      @close="close"
    >
      <slot />
      <template #footer>
        <div class="dialog-footer">
          <el-button v-if="isShowCancel" style="width: 144px" @click="cancel"
            >取消</el-button
          >
          <el-button
            :loading="loading"
            class="dialog-btn"
            type="primary"
            @click="really"
          >
            {{confirmText}}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
  <div v-else>
    <el-dialog
      v-model="isShowVisible"
      :width="width || '50%'"
      :title="title || ''"
      :close-on-click-modal="!clickModal"
      :top="top"
      append-to-body
    >
      <slot />
    </el-dialog>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";

interface Props {
  visible: boolean; // 显示
  title?: string; // 标题
  width?: string | number; // 宽度
  type?: number; // 类型
  clickModal?: boolean; //  modal不可点击
  top: string; // 距离顶部的距离
  isShowBtn: boolean; // 是否显示按钮
  isShowCancel: boolean;
  confirmText: string; // 确认文本
}

const props = withDefaults(defineProps<Props>(), {
  visible: false, // 显示
  title: "", // 标题
  width: "50%", // 宽度
  type: 0, // 类型
  clickModal: false, //  modal不可点击
  top: "15vh", // 距离顶部的距离
  isShowCancel: false,
  confirmText: "确认",
});

const emits = defineEmits<{
  (e: "update:visible", type: boolean): void;
  (e: "really"): void;
  (e: "close"): void;
  (e: "cancel"): void;
}>();

const loading = ref(false);

const close = () => {
  emits("close");
};

const really = async () => {
  emits("really");
};
const cancel = async () => {
  emits("cancel");
};

const isShowVisible = computed({
  get: () => props.visible,
  set: (val) => emits("update:visible", val),
});

defineExpose({
  loading,
});
</script>
<style scoped lang="scss">
.el-dialog {
  border-radius: 10px;
}
.el-dialog__header {
  padding: 20px 15px;
  margin: 0;
  border-bottom: 2px solid #e8eef8;
  display: flex;
  align-items: center;
}

.dialog-footer {
  text-align: center;
}
.dialog-btn {
  width: 144px;
  background-color: #5893f5;
}
</style>
